export default __webpack_public_path__ + "static/media/first-psychomotricite.243ca37d.jpg";